import { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

type Props = {
  title?: string;
  description?: string;
  image?: string;
  keywords?: string;
};

const SEO: FunctionComponent<Props> = ({
  title,
  description = 'Get started with a 1-min self-assessment to understand whether you may have ADHD and if Frida is a fit',
  image = 'Freddie_logo_green.png',
  keywords = 'ADHD, Frida',
}) => {
  const { t, i18n } = useTranslation('global', { keyPrefix: 'App' });
  const imgUrl = `${window.location.origin}/images/${image}`;
  const appName = t('SEOTitle');

  return (
    <Helmet
      defaultTitle={t('SEOTitle')}
      titleTemplate={t('TitleTemplate')}
      htmlAttributes={{ lang: i18n.language }}
    >
      <title>{title ?? appName}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="image: imgUrl" content={imgUrl} />
      <meta name="og:title" content={title ?? appName} />
      <meta name="og:description" content={description} />
      <meta name="og:image" content={imgUrl} />
      <meta name="og:type" content="website" />
      <meta name="twitter:creator" content="@GOFREDDlE" />
      <meta
        name="twitter:card"
        content={image ? 'summary_large_image' : 'summary'}
      />
      <meta name="twitter:title" content={title ?? appName} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imgUrl} />
      <meta name="twitter:alt" content={title ?? appName} />
    </Helmet>
  );
};

export default SEO;
